import { Link } from "react-router-dom";
import { Alert, Icon } from "@app/ui";
import { useOrgs } from "../orgs/OrgContext.js";
import { useT } from "../i18n.js";

/**
 * Shown in the app shell when the selected org is write-locked by billing:
 * delinquent (an issued invoice went overdue) or the free plan's yearly view
 * allowance is used up. Writes are locked server-side; this explains why and
 * links to the billing page. Renders nothing otherwise.
 */
export function DelinquentBanner() {
  const t = useT();
  const { org } = useOrgs();
  if (!org?.delinquent && !org?.viewLimitExceeded) return null;
  return (
    <Alert type={org.delinquent ? "error" : "warning"} className="app-banner" icon={false}>
      <div className="app-banner-row">
        <span className="app-banner-msg">
          <Icon
            name={org.delinquent ? "error" : "warning"}
            size={14}
            className={org.delinquent ? "text-[var(--az-error-accent)]" : "text-[var(--az-warning-accent)]"}
          />
          {org.delinquent ? t("billing.delinquentBanner") : t("billing.viewLimitBanner")}
        </span>
        <Link to="/billing">{t("billing.viewInvoices")}</Link>
      </div>
    </Alert>
  );
}
